var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaving(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#2B2826"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: -4.19999,
    y: -5.1999,
    width: 48.4,
    height: 46.4002
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(6.4px)",
      clipPath: "url(#bgblur_0_11072_82393_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_11072_82393)",
    "data-figma-bg-blur-radius": 12.8
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3163 8.55159C26.8724 8.07017 24.6489 7.46783 22.3872 8.86725C19.4938 7.73374 16.2865 7.92489 13.7312 9.23536C13.0617 9.57865 12.437 9.99928 11.8751 10.4923C11.3818 10.4309 11 10.0101 11 9.50007C11 8.94778 10.5523 8.50007 10 8.50007C9.44772 8.50007 9 8.94778 9 9.50007C9 10.5965 9.58824 11.5556 10.4664 12.079C9.5487 13.4228 9 15.0795 9 17.0003C9 19.3272 9.78178 21.2461 10.6548 22.7365C10.8806 23.1219 11 23.5237 11 23.9088V26.5003C11 27.3287 11.6716 28.0003 12.5 28.0003H15.0901C15.8051 28.0003 16.4208 27.4956 16.561 26.7945L16.6591 26.3039C16.7525 25.8364 17.163 25.4999 17.6397 25.4999H20.3603C20.837 25.4999 21.2474 25.8364 21.3409 26.3039L21.439 26.7945C21.5792 27.4956 22.1948 28.0003 22.9099 28.0003H25.5C26.3284 28.0003 27 27.3287 27 26.5003V24.3423C27 23.4246 27.6246 22.6246 28.5149 22.402L29.8638 22.0648C30.5315 21.8979 31 21.2979 31 20.6096V16.3605C31 15.7149 30.5869 15.1417 29.9743 14.9375L29.869 14.9024C29.418 14.7521 29.0281 14.4417 28.7668 14.0242C28.525 13.638 28.237 13.1868 27.9692 12.7913C27.8767 12.6547 27.7786 12.5125 27.6801 12.376L28.8944 9.94746C29.024 9.68819 29.0348 9.38542 28.9238 9.11761C28.8129 8.84979 28.5913 8.64329 28.3163 8.55159ZM20 13.5L16 13.5001C15.4477 13.5001 15 13.0524 15 12.5001C15 11.9478 15.4477 11.5001 16 11.5001L20 11.5C20.5523 11.5 21 11.9477 21 12.5C21 13.0523 20.5523 13.5 20 13.5ZM25 14.75C24.3096 14.75 23.75 15.3096 23.75 16C23.75 16.6904 24.3096 17.25 25 17.25C25.6904 17.25 26.25 16.6904 26.25 16C26.25 15.3096 25.6904 14.75 25 14.75Z",
    fill: "url(#paint0_linear_11072_82393)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3682 8.64563C24.6822 7.26298 26.9464 7.88347 28.3799 8.36145C28.7098 8.47151 28.9753 8.71984 29.1084 9.04114C29.2415 9.36252 29.2288 9.7261 29.0732 10.0372L27.9111 12.3595C27.987 12.4667 28.0638 12.5739 28.1348 12.6788C28.4045 13.0772 28.6943 13.531 28.9365 13.9181C29.1741 14.2976 29.5273 14.5779 29.9326 14.713L30.0371 14.7482C30.7313 14.9796 31.2002 15.6288 31.2002 16.3605V20.6095C31.2002 21.3896 30.6689 22.0697 29.9121 22.2589L28.5635 22.5958C27.7623 22.7961 27.2004 23.5161 27.2002 24.3419V26.5001C27.2002 27.439 26.4389 28.2003 25.5 28.2003H22.9102C22.0999 28.2003 21.4023 27.6285 21.2432 26.8341L21.1445 26.3429C21.0697 25.9691 20.7416 25.7003 20.3604 25.7003H17.6396C17.2584 25.7003 16.9303 25.9691 16.8555 26.3429L16.7568 26.8341C16.5978 27.6285 15.9001 28.2003 15.0898 28.2003H12.5C11.5611 28.2003 10.7998 27.439 10.7998 26.5001V23.9083C10.7997 23.5649 10.6932 23.198 10.4824 22.838C9.59795 21.328 8.7998 19.3735 8.7998 17.0001C8.79984 15.12 9.31546 13.4829 10.1875 12.1368C9.34999 11.5601 8.79982 10.5946 8.7998 9.50012C8.7998 8.83738 9.33726 8.29993 10 8.29993C10.6627 8.29993 11.2002 8.83738 11.2002 9.50012C11.2002 9.87948 11.465 10.1944 11.8193 10.2765C12.3741 9.80058 12.9862 9.39285 13.6396 9.05774C16.2198 7.73458 19.4464 7.53121 22.3682 8.64563ZM25 14.9503C24.4201 14.9503 23.9502 15.4202 23.9502 16.0001C23.9503 16.58 24.4201 17.0499 25 17.0499C25.5799 17.0499 26.0497 16.58 26.0498 16.0001C26.0498 15.4202 25.5799 14.9503 25 14.9503ZM16 11.7003C15.5582 11.7003 15.2002 12.0583 15.2002 12.5001C15.2002 12.9419 15.5582 13.2999 16 13.2999H20C20.4418 13.2999 20.7997 12.9419 20.7998 12.5001C20.7998 12.0583 20.4418 11.7003 20 11.7003H16Z",
    stroke: "#C58000",
    strokeOpacity: 0.48,
    strokeWidth: 0.4,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_11072_82393",
    x: -4.19999,
    y: -5.1999,
    width: 48.4,
    height: 46.4002,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.899346 0 0 0 0 0.713726 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11072_82393"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11072_82393",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_11072_82393_clip_path",
    transform: "translate(4.19999 5.1999)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3163 8.55159C26.8724 8.07017 24.6489 7.46783 22.3872 8.86725C19.4938 7.73374 16.2865 7.92489 13.7312 9.23536C13.0617 9.57865 12.437 9.99928 11.8751 10.4923C11.3818 10.4309 11 10.0101 11 9.50007C11 8.94778 10.5523 8.50007 10 8.50007C9.44772 8.50007 9 8.94778 9 9.50007C9 10.5965 9.58824 11.5556 10.4664 12.079C9.5487 13.4228 9 15.0795 9 17.0003C9 19.3272 9.78178 21.2461 10.6548 22.7365C10.8806 23.1219 11 23.5237 11 23.9088V26.5003C11 27.3287 11.6716 28.0003 12.5 28.0003H15.0901C15.8051 28.0003 16.4208 27.4956 16.561 26.7945L16.6591 26.3039C16.7525 25.8364 17.163 25.4999 17.6397 25.4999H20.3603C20.837 25.4999 21.2474 25.8364 21.3409 26.3039L21.439 26.7945C21.5792 27.4956 22.1948 28.0003 22.9099 28.0003H25.5C26.3284 28.0003 27 27.3287 27 26.5003V24.3423C27 23.4246 27.6246 22.6246 28.5149 22.402L29.8638 22.0648C30.5315 21.8979 31 21.2979 31 20.6096V16.3605C31 15.7149 30.5869 15.1417 29.9743 14.9375L29.869 14.9024C29.418 14.7521 29.0281 14.4417 28.7668 14.0242C28.525 13.638 28.237 13.1868 27.9692 12.7913C27.8767 12.6547 27.7786 12.5125 27.6801 12.376L28.8944 9.94746C29.024 9.68819 29.0348 9.38542 28.9238 9.11761C28.8129 8.84979 28.5913 8.64329 28.3163 8.55159ZM20 13.5L16 13.5001C15.4477 13.5001 15 13.0524 15 12.5001C15 11.9478 15.4477 11.5001 16 11.5001L20 11.5C20.5523 11.5 21 11.9477 21 12.5C21 13.0523 20.5523 13.5 20 13.5ZM25 14.75C24.3096 14.75 23.75 15.3096 23.75 16C23.75 16.6904 24.3096 17.25 25 17.25C25.6904 17.25 26.25 16.6904 26.25 16C26.25 15.3096 25.6904 14.75 25 14.75Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11072_82393",
    x1: 20,
    y1: 20.0044,
    x2: 20,
    y2: 25.4818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFBAA2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaving);
export default __webpack_public_path__ + "static/media/saving.8d0aa77406a64b5f7ccb0f67e04d60b3.svg";
export { ForwardRef as ReactComponent };